<template>
  <div class="curso">
    <router-view />
    <!-- <button class="edit-section">
      <img
        src="@/assets/icons/menu/edit-white.svg"
        style="z-index: 100"
        @click="redirect(course.id)"
      />
    </button> -->

    <img src="@/assets/img-course-thumb-default.png" />

    <div class="content">
      <p class="title">
        {{ course.name }}
      </p>

      <p class="description">
        {{ course.description }}
      </p>

      <div class="price">
        <span class="active">{{ course.newPrice }}</span
        ><span class="older">{{ course.oldPrice }}</span>
      </div>
      <div class="avaliation">
        <el-rate
          value="3.7"
          show-score
          text-color="#ff9900"
          disabled-void-color="#909bad"
          score-template="{value}  (21.954)"
          disabled
        >
        </el-rate>
        <span class="active">{{ course.newPrice }}</span
        ><span class="older">{{ course.oldPrice }}</span>
      </div>

      <el-button
        style="margin-top: 4px"
        type="success"
        class=""
        @click="redirect(course)"
        >Ver curso</el-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'CourseView',
  props: ['course'],
  methods: {
    ...mapActions('name', []),
    redirect(course) {
      console.log(this.$store.state.teacher);
      // courseId = this.
      // enderson/Curso-de-Bolsonaro
      let newstring = course.name.replaceAll(' ', '-');
      this.$router.push(
        `/${this?.$store?.state?.teacher?.name}/curso/${newstring}`
      , () => {
          console.log(course);
          this.$store.state.courses.course.id = course.id;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.curso {
  width: 100%;
  max-width: 348px;
  margin: 9px 9px;
  background: #fff;
  flex-grow: 1;
  flex-basis: 348px;
  position: relative;

  .edit-section {
    position: absolute;
    top: 1.5%;
    right: 1.5%;
    cursor: pointer;
    background: transparent;
    border: none;
  }

  img {
    display: block;
    width: 100%;
  }

  .content {
    padding: 20px 30px 25px 30px;

    .title {
      font-weight: 500;
      font-size: 1.25rem;
    }

    .description {
      font-weight: 400;
      color: #66788a;
    }

    .price {
      margin-top: 8px;
      margin-bottom: 10px;
    }

    button {
      margin: auto;
      width: 100%;
      height: 54px;
      font-weight: 500;
      font-size: 1.25rem;
    }
  }
}
.aprovado {
  background: #2cb55b;
}
.em_analise {
  background: gray;
}
@media (max-width: 768px) {
  .curso {
    margin: 9px 0;
  }
}
</style>